export enum ItemPepType {
  DEVICES = '1214',
  DIAGNOSIS = '1',
  CLINICAL_NOTE = '5',
  VITAL_SIGN = '13',
  INTAKES_OUTPUTS = '14',
  RESPIRATORY_MONITORING = '15',
  WOUNDS_DRESSINGS = '53',
  HEALTH_HISTORY = '93',
  SCORES_INDEXES = '374'
}

export interface RulesItemConfiguration {
  allowEditing: string,
  item: string,
  nrSequence: number,
}